
import { useParams, useNavigate } from 'react-router-dom';
import './ProjectsDetails.css';
import villa1 from '../assets/Residential/Villa/villa1.jpeg';
import villa2 from '../assets/Residential/Villa/villa2.jpeg'; 
import villa3 from '../assets/Residential/Villa/villa3.jpeg';
import villa4 from '../assets/Residential/Villa/villa4.jpeg';
import villa5 from '../assets/Residential/Villa/villa5.jpeg';
import villa6 from '../assets/Residential/Villa/villa6.jpeg';
import villa7 from '../assets/Residential/Villa/villa7.jpeg';
import villa8 from '../assets/Residential/Villa/villa8.jpeg';
import villa9 from '../assets/Residential/Villa/villa9.jpeg';
import flat1 from '../assets/Residential/Apartment/flat1.png';
import flat2 from '../assets/Residential/Apartment/flat2.png';
import flat4 from '../assets/Residential/Apartment/flat4.png';
import flat5 from '../assets/Residential/Apartment/flat5.png';
import flat6 from '../assets/Residential/Apartment/flat6.png';
import flat7 from '../assets/Residential/Apartment/flat7.png';
import flat8 from '../assets/Residential/Apartment/flat8.png';
import flat9 from '../assets/Residential/Apartment/flat9.png';
import flat10 from '../assets/Residential/Apartment/flat10.png';
import flat11 from '../assets/Residential/Apartment/flat11.png';
import flat12 from '../assets/Residential/Apartment/flat12.png';
import flat13 from '../assets/Residential/Apartment/flat13.png';
import flat14 from '../assets/Residential/Apartment/flat14.png';
import flat15 from '../assets/Residential/Apartment/flat15.png';
import ele1 from '../assets/Residential/elevations/ele1.jpeg';
import ele2 from '../assets/Residential/elevations/ele2.jpeg';
import ele3 from '../assets/Residential/elevations/ele3.jpeg';
import ele4 from '../assets/Residential/elevations/ele4.jpeg';
import ele5 from '../assets/Residential/elevations/ele5.jpeg';
import ind1 from '../assets/industrial/ind1.jpg';
import ind2 from '../assets/industrial/ind3.jpg';
import ind3 from '../assets/industrial/ind3.jpg';
import ind4 from '../assets/industrial/ind4.jpg';
import ind5 from '../assets/industrial/ind5.JPG';
import com1 from '../assets/Resort/1 (1).JPG';
import com2 from '../assets/Resort/1 (2).JPG';
import com3 from '../assets/Resort/1 (3).JPG';
import com4 from '../assets/Resort/1 (4).JPG';
import com5 from '../assets/Resort/1 (5).JPG';
import com6 from '../assets/Resort/3 (1).JPG';
import com7 from '../assets/Resort/3.JPG';

import ind7 from '../assets/industrial/main11.JPG';


const categories = [
  { id: 'residential', name: 'RESIDENTIAL', cards: [
      {
        title: 'Lavish Villa',
        address: 'Kompally,Hyderabad',
        images: [
           villa1,
          villa2,
          villa3,
          villa4,
          villa5,
          villa6,
          villa7,
          villa8,
          villa9
        ]
      },
      {
        title: 'Luxury Flat',
        address: 'Hitech City,Hyderabad',
        images: [
         flat1,
         flat2,
        
         flat4,
         flat5,
         flat6,
         flat7,
         flat8,
         flat9,
         flat10,
         flat11,
         flat12,
         flat13,
         flat14,
         flat15,
        ]
      },
      {
        title: 'Elevation',
        address: 'Hyderabad',
        images: [
          ele1,ele2,ele3,ele4,ele5
        ]
      },
    ]
  },
  { id: 'commercial', name: 'COMMERCIAL',title:'Resort Convention',address:'Shamashabad,Hyderabad', images: [
     com1,com2,com3,com4,com5,com6,com7
    ]
  },
  { id: 'industrial', name: 'INDUSTRIAL',title:'Seed Processing Unit',address:'Dabilpur,Hyderabad', images: [
    ind1,ind2,ind3,ind4,ind5,ind7
      
    ]
  },
];

const openGalleryTab = (card) => {
  const galleryWindow = window.open('', '_blank');
  if (galleryWindow) {
    galleryWindow.document.write(`
      <html>
        <head>
          <title>${card.title} Gallery</title>
          
          <style>
            body { font-family: sans-serif; margin: 0; padding: 0; background: #f8f9fa; }
            h2 { text-align: center; margin: 2rem 0 1rem 0; font-size: 2rem; }
            h6{ text-align:center; margin: 2rem 0 1rem 0;}
            .bento-grid {
              display: grid;
              grid-template-columns: repeat(3, 1fr); /* Always 3 images per row */
              gap: 2rem;
              padding: 2rem;
              max-width: 1400px;
              margin: 0 auto;
            }
            .bento-item {
              background: #fff;
              border-radius: 14px;
              box-shadow: 0 2px 12px rgba(0,0,0,0.07);
              overflow: hidden;
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 1rem;
            }
            .bento-item img {
              width: 100%;
              height: 320px;
              object-fit: cover;
              border-radius: 10px;
              margin-bottom: 0.5rem;
            }
            @media (max-width: 700px) {
              .bento-grid { grid-template-columns: 1fr; padding: 1rem; }
              .bento-item img { height: 160px; }
            }
          </style>
        </head>
        <body>
  <div >
    <h2>${card.title}</h2>
    <h6>${card.address}</h6>
  </div>
  <div class="bento-grid">
    ${card.images.map(img => `
      <div class="bento-item">
        <img src="${img}" alt="${card.title}" />
      </div>
    `).join('')}
  </div>
</body>

      </html>
    `);
    galleryWindow.document.close();
  }
};


const ProjectsDetails = () => {
  const { category } = useParams();
  const navigate = useNavigate();

  if (category) {
    const cat = categories.find(c => c.id === category);
    if (!cat) return <div>Category not found.</div>;

    if (category === 'residential') {
      return (
        <section className="projects-details-page">
  <div className="container">
    <h2 className="projects-column-title">{cat.name}</h2>
    <div className="residential-cards">
      {cat.cards.map((card, idx) => (
        <div className="residential-card" key={idx}>
          <h3>{card.title}</h3>
          <img
            src={card.images[0]}
            alt={card.title}
            onClick={() => openGalleryTab(card)} // Added this line
            style={{
              width: '250px',
              borderRadius: '8px',
              marginBottom: '0.5rem',
              cursor: 'pointer' // Optional: show pointer cursor
            }}
          />
          <div className="card-address">{card.address}</div>
          <span
            className="view-images-link"
            style={{
              color: '#007bff',
              cursor: 'pointer',
              fontSize: '0.95rem',
              marginTop: '0.5rem',
              display: 'inline-block'
            }}
            onClick={() => openGalleryTab(card)}
          >
            View Images
          </span>
        </div>
      ))}
    </div>
  </div>
</section>

      );
    } else {
      // For commercial and industrial, just show images
     return (
  <section className="projects-details-page">
    <div className="container">
      <h2 className="projects-column-title">{cat.name}</h2>
      <div style={{ textAlign: 'center' }}>
        <h2>{cat.title}</h2>
        <h6>{cat.address}</h6>
      </div>
      <div className="bento-grid">
        {cat.images.map((img, i) => (
          <div className="bento-item" key={i}>
            <img src={img} alt={`${cat.name} ${i + 1}`} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

    }
  }

  return (
    <section className="projects-details-page">
      <div className="container">
        <div className="projects-columns">
          {categories.map((cat) => (
            <div
              className="projects-column"
              key={cat.id}
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/projects/${cat.id}`)}
            >
              <h2 >{cat.name}</h2>
              <div className="service-image">
                {/* Show first image for preview */}
                <img src={cat.cards ? cat.cards[0].images[0] : cat.images[0]} alt={cat.name} style={{ width: '320px', borderRadius: '8px' }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsDetails;
// ...existing code...